import { IApplicationState } from '../../types/redux';

export const reliabilityEnabledSelector = (state: IApplicationState) => state.isReliabilityV2Enabled;
